import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search as SearchIcon } from "lucide-react";
import api from "@/lib/api";
import SEO from "@/components/SEO";
import ArtworkCard from "@/components/public/ArtworkCard";
import PoemCard from "@/components/public/PoemCard";
import { Input } from "@/components/ui/input";

export default function SearchPage() {
  const [params, setParams] = useSearchParams();
  const [q, setQ] = useState(params.get("q") || "");
  const [res, setRes] = useState(null);
  const [loading, setLoading] = useState(false);

  const runQuery = async (query) => {
    if (!query.trim()) return;
    setLoading(true);
    try {
      const { data } = await api.get("/search", { params: { q: query } });
      setRes(data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const initial = params.get("q");
    if (initial) runQuery(initial);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const run = (e) => {
    e.preventDefault();
    setParams(q.trim() ? { q: q.trim() } : {});
    runQuery(q);
  };

  return (
    <div className="on-dark violet-canvas fade-in flex-1 w-full">
      <div className="mx-auto max-w-4xl px-5 sm:px-8 py-12 sm:py-16">
      <SEO title="Suche" />
      <h1 className="font-serif text-5xl font-light mb-8">Suche</h1>
      <form onSubmit={run} className="relative mb-12">
        <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-[#B79FD1]" strokeWidth={1.5} />
        <Input
          data-testid="search-input"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Kunstwerke und Gedichte durchsuchen…"
          className="pl-12 h-14 text-lg bg-white rounded-md border-[#CBB4E4]"
          autoFocus
        />
      </form>

      {loading && <p className="text-[#B79FD1]">Suche läuft…</p>}

      {res && !loading && (
        <div className="space-y-14">
          <section>
            <h2 className="font-serif text-3xl mb-6">Kunstwerke ({res.artworks.length})</h2>
            {res.artworks.length ? (
              <div className="columns-1 sm:columns-2 gap-8">
                {res.artworks.map((a, i) => <ArtworkCard key={a.id} art={a} index={i} />)}
              </div>
            ) : <p className="text-[#B79FD1]">Keine Kunstwerke gefunden.</p>}
          </section>
          <section>
            <h2 className="font-serif text-3xl mb-2">Gedichte ({res.poems.length})</h2>
            {res.poems.length ? res.poems.map((p) => <PoemCard key={p.id} poem={p} />) : <p className="text-[#B79FD1]">Keine Gedichte gefunden.</p>}
          </section>
        </div>
      )}
      </div>
    </div>
  );
}
